import { render, staticRenderFns } from "./StudentLogin.vue?vue&type=template&id=a1e16f22&"
import script from "./StudentLogin.vue?vue&type=script&lang=ts&"
export * from "./StudentLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports